// App.tsx
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/main/LoginPage";
import ForgotPasswordPage from "./pages/main/ForgotPasswordPage";
import ResetPasswordPage from "./pages/main/ResetPasswordPage";
import ChangePasswordPage from "./pages/main/ChangePasswordPage";
import AdminPage from "./pages/main/AdminPage";
import SystemAdminPage from "./pages/main/SystemAdminPage";
import MySheet from "./pages/tf/MySheet";
import SheetExample from "./pages/tf/SheetExample";
import UserSheetsPage from "./pages/tf/UserSheetsPage";
import ViewingPermissionSetting from "./pages/tf/ViewingPermissionSetting";
import ProfilePage from "./pages/main/MyPage";
import ProtectedRoutes from "./routes/ProtectedRoutes";

// 権限制御
import RequireTfAdmin from "./routes/RequireTfAdmin";
import RequireTfSheetAccess from "./routes/RequireTfSheetAccess";
import RequirePublicOrSystemAdmin from "./routes/RequirePublicOrSystemAdmin";
import RequireProfileAccess from "./routes/RequireProfileAccess";

import NotFoundPage from "./pages/common/NotFoundPage";

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* 認証が必要なルート */}
          <Route element={<ProtectedRoutes />}>
            {/* 他のルート */}
            <Route
              path="/main/admin"
              element={
                <RequirePublicOrSystemAdmin>
                  <AdminPage />
                </RequirePublicOrSystemAdmin>
              }
            />
            <Route
              path="/main/system-admin"
              element={
                <RequirePublicOrSystemAdmin>
                  <SystemAdminPage />
                </RequirePublicOrSystemAdmin>
              }
            />
            <Route 
              path="/main/profile/:id?"
              element={
                <RequireProfileAccess>
                  <ProfilePage />
                </RequireProfileAccess>
              } 
              />
            <Route
              path="/main/change-password"
              element={<ChangePasswordPage />}
            />

            {/* 人材マネジメント */}
            <Route
              path="/tf/my-sheet/:userId"
              element={
                <RequireTfSheetAccess>
                  <MySheet />
                </RequireTfSheetAccess>
              }
            />
            <Route path="/tf/sheet-example" element={<SheetExample />} />
            <Route path="/tf/user-sheets" element={<UserSheetsPage />} />
            <Route
              path="/tf/viewing-permission"
              element={
                <RequireTfAdmin>
                  <ViewingPermissionSetting />
                </RequireTfAdmin>
              }
            />
          </Route>
          {/* 404ページ */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
